// pages/reports/CancelledTrainingsReport.js
import React, { useState } from 'react';
import { Button, Spinner, Table } from 'react-bootstrap';
import ReportFilterBar from '../../components/reports/ReportFilterBar';
import useReportData from '../../hooks/useReportData';

function CancelledTrainingsReport() {
  const [filters, setFilters] = useState(null);
  const { data, loading, error, exportUrl } = useReportData('reports/get_cancelled_trainings_report.php', filters);

  return (
    <div className="p-2">
      <div className="d-flex justify-content-between align-items-center no-print">
        <h2>Cancelled Trainings</h2>
        <div>
          <Button variant="outline-secondary" className="me-2" onClick={() => window.print()} disabled={!data}>
            Print
          </Button>
          {exportUrl && (
            <Button as="a" href={exportUrl} variant="outline-primary">
              Export to CSV
            </Button>
          )}
        </div>
      </div>

      <ReportFilterBar value={filters} onChange={setFilters} showDepartmentFilter={false} />

      {error && <div className="alert alert-danger">{error}</div>}
      {loading && <Spinner animation="border" size="sm" />}

      {data && !loading && (
        <>
          <h5 className="text-muted">{data.start} to {data.end}</h5>

          <h5 className="mt-3">Summary by Reason</h5>
          <Table striped bordered size="sm">
            <thead>
              <tr><th>Reason</th><th>Count</th></tr>
            </thead>
            <tbody>
              {data.summary.length > 0 ? data.summary.map((row, i) => (
                <tr key={i}>
                  <td>{row.reason || '(no reason given)'}</td>
                  <td>{row.total}</td>
                </tr>
              )) : (
                <tr><td colSpan="2" className="text-center">No cancelled trainings in this period</td></tr>
              )}
            </tbody>
          </Table>

          <h5 className="mt-4">Detail</h5>
          <Table striped bordered hover size="sm">
            <thead>
              <tr>
                <th>Code</th><th>Title</th><th>Start Date</th><th>End Date</th><th>Trainer</th><th>Reason</th>
              </tr>
            </thead>
            <tbody>
              {data.detail.length > 0 ? data.detail.map(t => (
                <tr key={t.id}>
                  <td>{t.code}</td>
                  <td>{t.title}</td>
                  <td>{t.start_date}</td>
                  <td>{t.end_date}</td>
                  <td>{t.assigned_trainer}</td>
                  <td>{t.reason || '(no reason given)'}</td>
                </tr>
              )) : (
                <tr><td colSpan="6" className="text-center">No cancelled trainings in this period</td></tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
}

export default CancelledTrainingsReport;
